import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { App } from "./App";
import { UniversityProvider } from "./contexts/UniversityContext";
import "./index.css";

// Ensure the root element exists
const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

// Create root and render app
const root = createRoot(rootElement);

// Wrap render in error boundary
try {
  root.render(
    <React.StrictMode>
      <Router>
        <UniversityProvider>
          <App />
        </UniversityProvider>
      </Router>
    </React.StrictMode>
  );
} catch (error) {
  console.error("Failed to render app:", error);
  // Render fallback UI
  root.render(
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-xl font-bold text-gray-800 mb-2">Something went wrong</h1>
        <p className="text-gray-600">Please try refreshing the page</p>
      </div>
    </div>
  );
}